"use client";

import { ReactNode } from "react";
import useRouterStuff from "hooks/useRouterStuff";
import { cn } from "lib/utils";

type ComponentProps = {
  children: ReactNode;
};

export default function CustomClientGrid({ children }: ComponentProps) {
  const { pathname } = useRouterStuff();

  const tabUrl = pathname?.split("/")[3];

  const onMainTab = !tabUrl || tabUrl === "/";

  return (
    <div
      className={cn(
        "bg-white rounded-lg py-8 px-6 flex flex-col gap-8",
        onMainTab ? "rounded-tl-none" : ""
      )}
    >
      {children}
    </div>
  );
}
